module.exports = __webpack_public_path__ + "static/img/1.1d4d68e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/1.png
// module id = 7Jdr
// module chunks = 0